import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID, REDUX_ACTIONS, CURRENT_SAVE_DATA_VERSION } from '../../data/constants';

const initialState = {
  saveFiles: {},
  levelId: 0,
  isLoaded: false,
};

const saveDataReducer = (state = initialState, action) => {
  const { type, payload, gameId } = action;

  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const { stateData } = action;
      const { GameData } = stateData[GAME_ID];
      if (GameData !== null && GameData !== undefined) {
        const { hasSeenOnboarding, currentSaveDataVersion, ...saveFiles } = GameData;
        if (currentSaveDataVersion !== undefined && currentSaveDataVersion === CURRENT_SAVE_DATA_VERSION) {
          return {
            ...state,
            saveFiles,
            isLoaded: true,
          };
        }
      }
      return {
        ...state,
        isLoaded: true,
      };
    }

    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...state,
        isLoaded: true,
      };

    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelId: payload.levelId,
      };

    case REDUX_ACTIONS.UPDATE_RECORDS: {
      const saveFiles = { ...state.saveFiles };
      // user has never played level before
      if (saveFiles[state.levelId] === undefined) {
        saveFiles[state.levelId] = { savedCuriosos: [], records: [] };
      // user has played game before and has savedCuriosos but still don't have records
      } else if (saveFiles[state.levelId].savedCuriosos.length > 0
        && saveFiles[state.levelId].records === undefined) {
        saveFiles[state.levelId] = {
          ...saveFiles[state.levelId],
          savedCuriosos: saveFiles[state.levelId]?.savedCuriosos || [],
          records: [],
        };
      }
      saveFiles[state.levelId].records = [...saveFiles[state.levelId].records, ...payload];
      return {
        ...state,
        saveFiles: { ...saveFiles },
      };
    }

    case REDUX_ACTIONS.MAKE_CURIOSO_ESCAPE:
    case REDUX_ACTIONS.REVEAL_CURIOSO: {
      const saveFiles = { ...state.saveFiles };
      if (saveFiles[state.levelId] === undefined) {
        saveFiles[state.levelId] = { savedCuriosos: [] };
      } else {
        saveFiles[state.levelId] = { ...saveFiles[state.levelId] };
      }
      const existingDataIndex = saveFiles[state.levelId].savedCuriosos.findIndex(e => e.index === payload);
      const newData = {
        index: payload,
        status: type === REDUX_ACTIONS.REVEAL_CURIOSO ? 'revealed' : 'escaped',
      };
      if (existingDataIndex === -1) {
        saveFiles[state.levelId].savedCuriosos.push(newData);
      } else {
        saveFiles[state.levelId].savedCuriosos[existingDataIndex] = newData;
      }

      return {
        ...state,
        saveFiles,
      };
    }

    case REDUX_ACTIONS.CLEAR_SAVE_FOR_CURRENT_LEVEL: {
      const saveFiles = { ...state.saveFiles };
      delete saveFiles[state.levelId];
      return {
        ...state,
        saveFiles,
      };
    }

    default:
      return state;
  }
};

export default saveDataReducer;
